import React, { type PropsWithChildren } from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { Modal } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const GroupOrderBagShareModal = (props: PropsWithChildren<Props>) => {
  const { visible, children, onClose } = props;

  const { formatMessage } = useIntl();

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <Modal
      visible={visible}
      size="medium"
      fitHeight
      onRequestClose={onClose}
      accessibilityLabel={formatMessage(messages.accessibilityLabel)}
    >
      {children}
    </Modal>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  accessibilityLabel: {
    defaultMessage: 'Invite others',
    description: 'Bag | Group order share modal | Accessibility label',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  visible: boolean;
  onClose: () => void;
};
